import { createClient } from '@supabase/supabase-js'

// Using the verified credentials
const SUPABASE_URL = 'https://bndhkaiyabqemebgzvbq.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJuZGhrYWl5YWJxZW1lYmd6dmJxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg0NjcxMDksImV4cCI6MjA3NDA0MzEwOX0.XRB3lKDL5NLtr16b8auTH_e1_ZvxM-shrDp1VHDVMAY'

// Validate credentials
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'cycle-ceo-auth',
    storage: window.localStorage,
    // Configure for easier signup without email confirmation
    flowType: 'pkce'
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'apikey': SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${SUPABASE_ANON_KEY}`
    }
  },
  // Add retry logic for network issues
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
})

// Test connection function
export const testConnection = async () => {
  try {
    const { data, error } = await supabase.auth.getSession()
    console.log('Supabase connection test:', { connected: !error, error })
    return !error
  } catch (err) {
    console.error('Supabase connection failed:', err)
    return false
  }
}

export default supabase